import axios from 'axios'
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPercentage(percentage: number) {
  let result = percentage < 10 ? percentage.toFixed(1) : Math.round(percentage).toString()

  return `${percentage > 0 ? '+' : ''}${result.replace('.', ',')}%`
}

export function getAxiosErrorMessage(error: unknown, fallbackMessage?: string) {
  if (
    axios.isAxiosError(error) &&
    error.response?.data &&
    'message' in error.response.data &&
    typeof error.response.data.message === 'string'
  ) {
    return error.response.data.message
  }

  if (
    axios.isAxiosError(error) &&
    error.response?.data &&
    'error' in error.response.data &&
    typeof error.response.data.error === 'string'
  ) {
    return error.response.data.error
  }

  return fallbackMessage ?? 'Une erreur inconnue est survenue, veuillez contacter le support'
}

export function trimSeconds<T extends string | null>(time: T): T {
  if (!time) return time
  return time.slice(0, 5) as T
}

export const numberFormatter = new Intl.NumberFormat('fr-FR')
